import { SimpleEditor } from "app/components/TextEditor/components/tiptap-templates/simple/simple-editor";
import resizeDescription from "assets/svgs/resize-description.svg";
import clsx from "clsx";
import React, { ComponentProps, FC, useRef, useState } from "react";

const MIN_HEIGHT = 250;

const DescriptionPreview: FC<{
  editorProps?: ComponentProps<typeof SimpleEditor>;
  hideResizeIcon?: boolean;
  className?: string;
}> = ({ editorProps, hideResizeIcon = false, className }) => {
  // Local States
  const [height, setHeight] = useState<number>(240);

  // Refs for resizing
  const startYRef = useRef<number | null>(null);
  const startHeightRef = useRef<number>(height);

  // Functions
  const handleMouseDown = (e: React.MouseEvent<HTMLImageElement>) => {
    e.preventDefault();
    startYRef.current = e.clientY;
    startHeightRef.current = height;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (startYRef.current !== null && startHeightRef.current !== undefined) {
      const diff = e.clientY - startYRef.current;
      let newHeight = startHeightRef.current + diff;
      newHeight = Math.max(MIN_HEIGHT, newHeight);
      setHeight(newHeight);
    }
  };

  const handleMouseUp = () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
    startYRef.current = null;
  };

  return (
    <div className="relative overflow-y-auto">
      <div
        className={clsx(
          "py-4 border border-gray-100 rounded-md cursor-text",
          className,
        )}
        style={{ height }}
      >
        <SimpleEditor
          {...editorProps}
          className={editorProps?.className || "px-4"}
        />
      </div>
      {hideResizeIcon ? null : (
        <img
          src={resizeDescription}
          alt="Resize Description"
          className="absolute bottom-[1px] right-[1px] cursor-ns-resize select-none"
          style={{ zIndex: 10 }}
          onMouseDown={handleMouseDown}
          draggable={false}
        />
      )}
    </div>
  );
};

export default DescriptionPreview;
